import { store } from "../../store/store";

export function getApiInformation() {
    const state = store.getState();
    const parametersState = (state as any).reactAppParameters;

    return {
        apiKey: parametersState?.reactAppParameters?.react_app_api_key,
        apiSecret: parametersState?.reactAppParameters?.react_app_api_secret
    };
}